import { ReactNode } from "react";
import { Box, Paper, Typography } from "@mui/material";
import { tokens } from "../../theme";

/**
 * La tarjeta de las pantallas de acceso: entrar y recuperar la contraseña.
 *
 * Es la Tarjeta del kit (§06) —borde de 1px, radio 8— con su título en Poppins, y
 * existe para que las tres pantallas del flujo se vean como una sola cosa en vez de
 * como tres páginas sueltas. Va dentro de `PublicLayout`, así que no trae barra ni
 * logo: esos los pone el sitio.
 *
 * `icono` y `centrado` son para el login, que es la portada del acceso y se presenta
 * como tal; las de contraseña son pantallas de trámite y van alineadas a la izquierda,
 * que es como se lee un formulario.
 */
export function TarjetaAcceso({
  titulo,
  bajada,
  icono,
  centrado = false,
  children,
}: {
  titulo: string;
  bajada?: string;
  icono?: ReactNode;
  centrado?: boolean;
  children: ReactNode;
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: "8px",
        p: { xs: 2.5, sm: "22px" },
        bgcolor: "background.paper",
        textAlign: centrado ? "center" : "left",
      }}
    >
      {icono && (
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            bgcolor: "primary.main",
            color: tokens.neutro.blanco,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 1.5,
          }}
        >
          {icono}
        </Box>
      )}
      <Typography variant="h6" sx={{ color: tokens.marca.texto }}>
        {titulo}
      </Typography>
      {bajada && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, mb: 2.5 }}>
          {bajada}
        </Typography>
      )}
      {children}
    </Paper>
  );
}
